'use client'

import { memo } from 'react'
import { MdBedroomParent } from 'react-icons/md'

interface EmptyStateProps {
  title: string
  description: string
}

function EmptyState({ title, description }: EmptyStateProps) {
  return (
    <div className="flex h-[calc(100vh-135px)] min-h-[300px] flex-col items-center justify-center rounded-[8px] bg-[#fff] p-6 text-center text-sm text-[#666B74] shadow-sm">
      <div className="mb-3">
        <MdBedroomParent className="h-10 w-10 text-primary-500" />
      </div>
      <p className="text-base font-medium text-[#333]">{title}</p>
      <p className="mt-1 text-xs text-[#333]">{description}</p>
    </div>
  )
}

function arePropsEqual(prevProps: EmptyStateProps, nextProps: EmptyStateProps) {
  return prevProps.title === nextProps.title && prevProps.description === nextProps.description
}

export default memo(EmptyState, arePropsEqual)
